export const categoryOptions = [
  { text: "Drinks", value: "drinks" },
  { text: "Culture", value: "culture" },
  { text: "Film", value: "film" },
  { text: "Food", value: "food" },
  { text: "Music", value: "music" },
  { text: "Travel", value: "travel" },
];

export const priorityOptions = [
  { text: "Urgent", value: "Urgent" },
  { text: "Medium", value: "Medium" },
  { text: "Low", value: "Low" },
];

export const userRoleOptions = [
  { text: "Admin Manager", value: "1" },
  { text: "Store Manager", value: "2" },
  { text: "Accountant", value: "3" },
  { text: "Cashier", value: "4" },
];
export const selectStateOptions = [
  { key: "Abia", value: "Abia" },
  { key: "Adamawa", value: "Adamawa" },
  { key: "Akwa Ibom", value: "Akwa Ibom" },
  { key: "Anambra", value: "Anambra" },
  { key: "Bauchi", value: "Bauchi" },
  { key: "Bayelsa", value: "Bayelsa" },
  { key: "Benue", value: "Benue" },
  { key: "Borno", value: "Borno" },
  { key: "Cross River", value: "Cross River" },
  { key: "Delta", value: "Delta" },
  { key: "Ebonyi", value: "Ebonyi" },
  { key: "Edo", value: "Edo" },
  { key: "Ekiti", value: "Ekiti" },
  { key: "Enugu", value: "Enugu" },
  { key: "FCT", value: "FCT" },
  { key: "Gombe", value: "Gombe" },
  { key: "Imo", value: "Imo" },
  { key: "Jigawa", value: "Jigawa" },
  { key: "Kaduna", value: "Kaduna" },
  { key: "Kano", value: "Kano" },
  { key: "Katsina", value: "Katsina" },
  { key: "Kebbi", value: "Kebbi" },
  { key: "Kogi", value: "Kogi" },
  { key: "Kwara", value: "Kwara" },
  { key: "Lagos", value: "Lagos" },
  { key: "Nasarawa", value: "Nasarawa" },
  { key: "Niger", value: "Niger" },
  { key: "Ogun", value: "Ogun" },
  { key: "Ondo", value: "Ondo" },
  { key: "Osun", value: "Osun" },
  { key: "Oyo", value: "Oyo" },
  { key: "Plateau", value: "Plateau" },
  { key: "Rivers", value: "Rivers" },
  { key: "Sokoto", value: "Sokoto" },
  { key: "Taraba", value: "Taraba" },
  { key: "Yobe", value: "Yobe" },
  { key: "Zamfara", value: "Zamfara" },
];
export const stateOptions = [
  { key: "Abia", text: "Abia", value: "Abia" },
  { key: "Adamawa", text: "Adamawa", value: "Adamawa" },
  { key: "Akwa Ibom", text: "Akwa Ibom", value: "Akwa Ibom" },
  { key: "Anambra", text: "Anambra", value: "Anambra" },
  { key: "Bauchi", text: "Bauchi", value: "Bauchi" },
  { key: "Bayelsa", text: "Bayelsa", value: "Bayelsa" },
  { key: "Benue", text: "Benue", value: "Benue" },
  { key: "Borno", text: "Borno", value: "Borno" },
  { key: "Cross River", text: "Cross River", value: "Cross River" },
  { key: "Delta", text: "Delta", value: "Delta" },
  { key: "Ebonyi", text: "Ebonyi", value: "Ebonyi" },
  { key: "Edo", text: "Edo", value: "Edo" },
  { key: "Ekiti", text: "Ekiti", value: "Ekiti" },
  { key: "Enugu", text: "Enugu", value: "Enugu" },
  { key: "FCT", text: "FCT", value: "FCT" },
  { key: "Gombe", text: "Gombe", value: "Gombe" },
  { key: "Imo", text: "Imo", value: "Imo" },
  { key: "Jigawa", text: "Jigawa", value: "Jigawa" },
  { key: "Kaduna", text: "Kaduna", value: "Kaduna" },
  { key: "Kano", text: "Kano", value: "Kano" },
  { key: "Katsina", text: "Katsina", value: "Katsina" },
  { key: "Kebbi", text: "Kebbi", value: "Kebbi" },
  { key: "Kogi", text: "Kogi", value: "Kogi" },
  { key: "Kwara", text: "Kwara", value: "Kwara" },
  { key: "Lagos", text: "Lagos", value: "Lagos" },
  { key: "Nasarawa", text: "Nasarawa", value: "Nasarawa" },
  { key: "Niger", text: "Niger", value: "Niger" },
  { key: "Ogun", text: "Ogun", value: "Ogun" },
  { key: "Ondo", text: "Ondo", value: "Ondo" },
  { key: "Osun", text: "Osun", value: "Osun" },
  { key: "Oyo", text: "Oyo", value: "Oyo" },
  { key: "Plateau", text: "Plateau", value: "Plateau" },
  { key: "Rivers", text: "Rivers", value: "Rivers" },
  { key: "Sokoto", text: "Sokoto", value: "Sokoto" },
  { key: "Taraba", text: "Taraba", value: "Taraba" },
  { key: "Yobe", text: "Yobe", value: "Yobe" },
  { key: "Zamfara", text: "Zamfara", value: "Zamfara" },
];

export const regionOptions = [
  { key: "North Central", text: "North Central", value: "North Central" },
  { key: "North East", text: "North East", value: "North East" },
  { key: "North West", text: "North West", value: "North West" },
  { key: "South East", text: "South East", value: "South East" },
  { key: "South West", text: "South West", value: "South West" },
  { key: "South South", text: "South South", value: "South South" },
];
